import React, {useEffect, useState} from 'react';
import {Grid} from '@material-ui/core';
import {Ranking, StackedChart, TotalDeals, TotalPoint} from '../index';
import {getReportCompare} from '../../../../apis/api';
import CircularProgress from '@material-ui/core/CircularProgress';

// eslint-disable-next-line react/no-multi-comp
const Loading = () => (
    <div style={{display: 'flex', width: '100%', justifyContent: 'center', paddingTop: '20px'}}>
        <CircularProgress />
    </div>
);

const Performance = ({term = '', options = {}}) => {
    const {category1, category2, targetDate, compareDate} = options;
    const [dataset, setDataset] = useState({
        loading: false,
        data: {},
    });

    useEffect(() => {
        setDataset({
            loading: true,
            data: {},
        });
        getReportCompare({term, category1, category2, targetDate, compareDate})
            .then((res) => {
                setDataset({
                    loading: false,
                    data: res.data,
                });
            }).catch(() => {
                setDataset({
                    loading: false,
                    data: {},
                });
            });
    },[term, category1, category2, targetDate, compareDate]);

    if (dataset.loading) return <Loading />;

    return (
        <>
            <Grid
                item
                lg={8}
                md={8}
                sm={12}
                xl={8}
                xs={12}
            >
                <StackedChart
                    term={term}
                    data={dataset.data.platformPoints}
                />
            </Grid>
            <Grid
                container
                item
                lg={4}
                md={4}
                sm={12}
                xl={4}
                xs={12}
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    style={{marginBottom: '16px'}}
                    xl={12}
                    xs={12}
                >
                    <TotalPoint
                        term={term}
                        data={dataset.data.point}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <TotalDeals
                        term={term}
                        data={dataset.data.deals}
                    />
                </Grid>
            </Grid>
            <Grid
                item
                lg={12}
                md={12}
                xl={12}
                xs={12}
            >
                <Ranking
                    term={term}
                    data={dataset.data.rankings}
                />
            </Grid>
        </>
    );
};

export default Performance;
